// #region imports

// --- Angular
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { BehaviorSubject, Subscription, combineLatest } from 'rxjs';

// --- HS Code
import { GroupModel, RespondentModel, SurveyResponseModel } from '../../../models';

// #endregion

@Component({
  selector: 'hs-manage-respondents-modal-v2',
  templateUrl: './manage-respondents-modal-v2.component.html',
  styleUrls: ['./manage-respondents-modal-v2.component.scss']
})
export class ManageRespondentsModalV2Component implements OnChanges, OnDestroy {

  @Input() canSave: boolean = false;
  @Input() groups: GroupModel[] | null = null;
  @Input() hasChanges: boolean = false;
  @Input() surveyResponse: SurveyResponseModel | null = null;
  @Input() isMobile: boolean | null = false;

  @Output() addGroupClicked = new EventEmitter<SurveyResponseModel>();
  @Output() addRespondent = new EventEmitter<{}>();
  @Output() deleteRespondent = new EventEmitter<RespondentModel>();
  @Output() dismissClicked = new EventEmitter<{}>();
  @Output() editGroupName = new EventEmitter<GroupModel>();
  @Output() moveRespondent = new EventEmitter<{}>();
  @Output() saveClicked = new EventEmitter<string>();

  canAddGroups: boolean = false;

  private _canAddGroupsSubscription: Subscription = Subscription.EMPTY;
  private _groupsSubject$: BehaviorSubject<GroupModel[] | null> = new BehaviorSubject<GroupModel[] | null>(null);
  private _surveyResponseSubject$: BehaviorSubject<SurveyResponseModel | null> = new BehaviorSubject<SurveyResponseModel | null>(null);

  constructor() {
    this._canAddGroupsSubscription = combineLatest({
      groups: this._groupsSubject$,
      surveyResponse: this._surveyResponseSubject$
    }).subscribe(({groups, surveyResponse}) => {
      if (!groups || !surveyResponse) return;

      this.canAddGroups = surveyResponse?.numberOfGroups > groups?.length;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['groups']) {
      this._groupsSubject$.next(this.groups);
    }

    if (changes && changes['surveyResponse'] && changes['surveyResponse'].currentValue) {
      this._surveyResponseSubject$.next(this.surveyResponse);
    }
  }

  ngOnDestroy(): void {
    if (this._canAddGroupsSubscription !== Subscription.EMPTY) {
      this._canAddGroupsSubscription.unsubscribe();
      this._canAddGroupsSubscription = Subscription.EMPTY;
    }
  }

  onDismissModalClicked(): void {
    this.dismissClicked.emit({ hasChanges: this.hasChanges, reason: 'Cross clicked'});
  }

  onSaveClick(): void {
    if (!this.surveyResponse) return;

    this.saveClicked.emit(this.surveyResponse.id);
  }

  onAddGroup(): void {
    if (!this.surveyResponse) return;
    this.addGroupClicked.emit(this.surveyResponse);
  }
}
